import { ShouldUseResponsiveLayoutService } from '@feature/_app_modules/layout/services/should-use-responsive-layout.service';
import { Component, OnInit, Input, OnDestroy, Inject } from '@angular/core';
import { BrandService } from '../services/brand.service';
import { Brand } from '../models/brand';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'mojo-brand-css-loader',
  templateUrl: './brand-css-loader.html'
})
export class BrandCssLoaderComponent implements OnInit, OnDestroy {

  isAlive: boolean = false;

  @Input()
  cssDocumentElementSelector: string = 'brand-style';

  private brand: Observable<Brand>;

  ngOnInit() {

    this.isAlive = true;
    this.brand = this.brandService.getCurrentBrand();

    this.shouldUseResponsiveLayoutService.useResponsiveLayout$.subscribe(useresponsive => {

      // do not load brands if responsive is used
      if (!useresponsive) {

        this.brand.pipe(takeWhile(() => this.isAlive)).subscribe((brand: Brand) => {
          this.loadBrandCss(brand);
        });
    
      }

    });



  }

  private loadBrandCss(brand: Brand): void {
    const head = this.document.getElementsByTagName('head')[0];
    const brandElementiD = 'brand-style';

    let themeLink = this.document.getElementById(brandElementiD) as HTMLLinkElement;

    if (themeLink) {
      themeLink.href = brand.styleSheetName;
    } else {
      const style = this.document.createElement('link');
      style.id = brandElementiD;
      style.rel = 'stylesheet';
      style.href = `${brand.styleSheetName}`;
      head.appendChild(style);
    }
  }

  ngOnDestroy() {
    this.isAlive = false;
  }

  constructor(
    private readonly shouldUseResponsiveLayoutService: ShouldUseResponsiveLayoutService,
    @Inject(DOCUMENT) private document: Document,
    private readonly brandService: BrandService
  ) { }

}
